import { ButtonProps } from "./button.interface";
import styles from "./index.module.scss";
import { Button } from "primereact/button";

const ButtonC = ({
  label,
  type,
  size,
  btnType,
  icon,
  iconPos,
  bgColor,
  onClick,
  tabIndex,
  text,
  btnWrapClassName,
  ...props
}: ButtonProps) => {
  return (
    <div className={`${styles.btn} ${btnWrapClassName}`}>
      <Button
        type={type}
        disabled={props.disabled}
        className={[
          styles["btn"],
          styles[`${btnType}`],
          styles[`${size}`],
          styles[`${iconPos}`],
          styles[`${bgColor}`],
          props.className
        ].join(" ")}
        label={label}
        icon={icon}
        iconPos={iconPos}
        tabIndex={tabIndex || 0}
        text={text || null}
        onClick={onClick}
        loading={props.loading}
      />
    </div>
  );
};
export default ButtonC;
